import React from "react";
import './CenteredDiv.css';
import { Link } from 'react-router-dom';


export default function QuizFinal() {
    return (
        <div className="centereddiv">
            <h1>What did you think babe! Did you have fun? Try again but with wrong answers :)</h1>
            <nav className="nav-links">
                <Link to="/quiz">Try Again</Link>
                <Link to="/home">Home</Link>
            </nav>
        </div>
    )
}